import React from 'react';
import './Loading.css';
import potuslogo from '../assets/potuslogo.png';
import maga from '../assets/maga.png';

function Loading() {
  return (
    <div className="loading-container">
      <div className="loading-content">
        <img src={potuslogo} alt="POTUS" className="loading-logo pulse" />
        <img src={maga} alt="MAGA" className="loading-maga rotate" />
        <div className="loading-text">
          <div className="letter-container">
            {['M','A','K','I','N','G',' ','A','M','E','R','I','C','A',' ','G','R','E','A','T',' ','A','G','A','I','N'].map((letter, index) => (
              <span 
                key={index} 
                className="bounce-letter"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {letter}
              </span>
            ))}
          </div>
        </div>
        <div className="loading-bar">
          <div className="loading-progress"></div>
        </div>
      </div>
    </div>
  );
}

export default Loading; 